<script>
    export let page;
    export let submenus;
</script>

<nav>
    {#each submenus as button}
        <div style="--selected: {page == button.page ? 0.35 : 0};" on:click="{() => page = button.page}">
            {#if button.html}
                <p>{@html button.name}</p>
            {:else}
                <p>{button.name}</p>
            {/if}
        </div>
    {/each}
</nav>

<style>
    nav {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        column-gap: 1%;
    }
    
    div {
        margin: auto 0;
        cursor: pointer;
        text-align: center;
        white-space: nowrap;
        border-radius: 10px;
        border: 3px solid rgba(221, 221, 221, var(--selected));
        transition: border-color 0.5s;
    }

    div:hover {
        border-color: #ddd;
    }
    
    p {
        margin: 3px;
        padding: 5px;
        border-radius: 5px;
        background-color: #efefef;
        transition: background-color 0.5s;
    }
    
    div:hover > p {
        background-color: #ddd;
    }
</style>